var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { useCard } from './CardContext.js';
export const CardFooter = props => {
    const { withBorder = false, children, className } = props, rest = __rest(props, ["withBorder", "children", "className"]);
    const { padding } = useCard();
    return (React.createElement("div", Object.assign({ className: clsx(padding === 'md' && 'px-4 py-5 sm:p-6 ', padding === 'sm' && 'px-4 py-5 sm:px-3', !withBorder && 'pt-0 sm:pt-0', withBorder && 'border-t border-surface-200/50', className) }, rest), children));
};
export const CardActions = props => {
    const { withBorder = false, children, className } = props, rest = __rest(props, ["withBorder", "children", "className"]);
    const { padding } = useCard();
    return (React.createElement("div", Object.assign({ className: clsx(padding === 'md' && 'px-4 py-5 sm:p-6 ', padding === 'sm' && 'px-4 py-5 sm:px-3', 'sm:flex sm:flex-row-reverse space-x-2 space-x-reverse', !withBorder && 'pt-0 sm:pt-0', withBorder && 'border-t border-surface-200/50', className) }, rest), children));
};
//# sourceMappingURL=CardFooter.js.map